// src/components/Toast.js
//
// Notificações não bloqueantes (substituem o alert() nativo).
// Uso em qualquer lugar:  toast.success("Salvo!")  /  toast.error("Falhou")
// O <ToastHost /> fica montado uma única vez no App.
import React, { useEffect, useState } from "react";
import { CircleCheck, CircleAlert, Info, TriangleAlert, X } from "lucide-react";

let listeners = [];
let nextId = 1;

function emit(type, text, duration) {
  const item = { id: nextId++, type, text: String(text ?? ""), duration };
  listeners.forEach((fn) => fn(item));
}

export const toast = {
  success: (text, duration = 4000) => emit("success", text, duration),
  error: (text, duration = 6000) => emit("error", text, duration),
  info: (text, duration = 5000) => emit("info", text, duration),
  warning: (text, duration = 6000) => emit("warning", text, duration),
};

const ICONS = {
  success: CircleCheck,
  error: CircleAlert,
  info: Info,
  warning: TriangleAlert,
};

export function ToastHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const onToast = (item) => {
      setItems((prev) => [...prev.slice(-3), item]);
      if (item.duration > 0) {
        setTimeout(() => {
          setItems((prev) => prev.filter((t) => t.id !== item.id));
        }, item.duration);
      }
    };
    listeners.push(onToast);
    return () => {
      listeners = listeners.filter((fn) => fn !== onToast);
    };
  }, []);

  const dismiss = (id) => setItems((prev) => prev.filter((t) => t.id !== id));

  return (
    <div className="toast-host" aria-live="polite" aria-atomic="false">
      {items.map((t) => {
        const Icon = ICONS[t.type] || Info;
        return (
          <div key={t.id} className={`toast is-${t.type}`} role={t.type === "error" ? "alert" : "status"}>
            <Icon aria-hidden="true" />
            <span className="toast-text">{t.text}</span>
            <button type="button" className="toast-close" onClick={() => dismiss(t.id)} aria-label="Fechar notificação">
              <X />
            </button>
          </div>
        );
      })}
    </div>
  );
}
